// extracted by mini-css-extract-plugin
module.exports = {"searchHighlight":"utils_searchHighlight__QeRvm"};